export enum SeasonTicketsPages {
  buyTicket = 'buyTicket',
  selectedAreaId = 'selectedAreaId',
  selectedTableId = 'selectedTableId',
}
